<template>
	<div class="o-dashboard">

		<c-table
			:columns="columns"
			:endpoint="'/api/users'"
            ref="table"
            :placeholder="'Zoeken op naam of email'">
		</c-table>

		</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';

export default {
	mixins: [ View, Form ],
	components: {CTable},
    methods: {
        exportUsers() {
            const link = document.createElement('a');
            link.href = '/api/exportusers?search=' + this.$refs.table.selection.search.all + '&sort=' + this.$refs.table.sort.column + '&order=' + this.$refs.table.sort.direction;
            document.body.appendChild(link);
            link.click();
        },
    },
	computed: {
		columns() {
			let columns = [
				{ name: 'name', label: 'Naam', sortable: true, sort: true },
				{ name: 'email', label: 'Email', sortable: true },
				{ name: 'roles.*.name', label: 'Rol'},
				{ name: "id", label: '', component: 'CColumnButton', props: { route: 'userDetails' }},
			];

			return columns;
		}
	},
    beforeUnmount(){
        this.$store.dispatch('listener/off', {
            event: 'export',
            listener: this.exportUsers
        });
    },
    created(){
        this.$store.dispatch('listener/on', {
            event: 'export',
            listener: this.exportUsers
        });
    },
}
</script>
